import instance from './api';
import { AxiosResponse } from 'axios';
import { IUserWithTokens } from '../helpers/types';

export interface UsersListResponse {
    rows: IUserWithTokens[];
    count: number;
}

export default class UsersService {
    static async findAll(
        page = 1,
        limit = 10
    ): Promise<AxiosResponse<UsersListResponse>> {
        return instance.get<UsersListResponse>('users', {
            params: { page, limit },
        });
    }

    static async update(
        id: number,
        data: { login: string; password?: string }
    ): Promise<AxiosResponse<IUserWithTokens>> {
        return instance.put<IUserWithTokens>(`users/${id}`, data);
    }

    static async deleteToken(userId: number, tokenId: number) {
        return instance.delete(`users/${userId}/tokens/${tokenId}`);
    }

    static async create(
        login: string,
        password: string
    ): Promise<AxiosResponse<IUserWithTokens>> {
        return instance.post<IUserWithTokens>('users', { login, password });
    }

    static async setRole(userId: number, title: string) {
        return instance.post('users/role', { userId, title });
    }

    static async getOne(
        id: number
    ): Promise<AxiosResponse<IUserWithTokens>> {
        return instance.get<IUserWithTokens>(`users/${id}`);
    }
}
